import Preferences from 'context/preferences';
import { hasFullScope } from '../common/scope';

// Per session, because a mission id belongs to the session's namespace and a blob can hold more than one.
export function selectedMissionKey(sessionId) {
  return `blob:workflow.missionControl.selectedMission.${sessionId}`;
}

export function rememberMission(scope, sessionId, missionId) {
  if (!hasFullScope(scope) || !sessionId || !missionId) return;
  Preferences.set(selectedMissionKey(sessionId), missionId, scope);
}

export function rememberedMission(scope, sessionId) {
  if (!hasFullScope(scope) || !sessionId) return null;
  return Preferences.get(selectedMissionKey(sessionId), scope) || null;
}
